import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import './UnsubscribeEmail.css';

function UnsubscribeEmail() {
    const location = useLocation();
    const { email } = location.state || {};

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);

    const handleConfirmUnsubscribe = async () => {
        setLoading(true);
        setError(null);
        setSuccess(false);
        try {
            const response = await fetch('https://services.DorisTMS.rev.ky.gov/api/Users/UnSubscribe', {
           // const response = await fetch('https://localhost:44390/api/Users/UnSubscribe', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ emailAddress:email }),
            });
            const data = await response.json();
            if (response.ok) {
                setSuccess(true);
            } else {
                setError(data.message || 'Something went wrong');
            }
        } catch (err) {
            setError(err.message || 'Error connecting to server');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="success-container">
            <h1 className="header">Unsubscribe Email</h1>
            <p className="info-text">You are about to unsubscribe from KY Department of Revenue's MyTaxes eMails.</p>
            <p className="email-text">
                Email: <strong>{email}</strong>
            </p>
            {error && <div className="error-message">{error}</div>}
            {success && <div className="success-message">You have successfully unsubscribed!</div>}
            <button
                className="confirm-btn"
                onClick={handleConfirmUnsubscribe}
                disabled={loading}
            >
                {loading ? 'Unsubscribing...' : 'Click here to Unsubscribe'}
            </button>
        </div>
    );
}

export default UnsubscribeEmail;
